var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',[_c('v-app-bar-nav-icon',{on:{"click":function($event){$event.stopPropagation();return _vm.toggleMenu.apply(null, arguments)}}}),_c('v-toolbar-title',{domProps:{"textContent":_vm._s(_vm.title)}}),_c('v-spacer'),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.logout}},[_vm._v("Log Out")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }